import React from 'react';

export default class TimeSheetNavItem extends React.Component {
  render() {
    const classNames = this.props.section == this.props.activePage ? 'active' : 'default';
    if (this.props.shouldRender == false) {
      return false;
    }
    return (
      <li onClick={() => this.props.onClickHandler(this.props.section)}>
        <a className={classNames}>
          <span>{this.props.text}</span>
        </a>
      </li>
    );
  }
}
